import React from 'react';

import CustomBlocks from '../../blocks/CustomBlocks/CustomBlocks';
import { RM_TAGS } from '../../const';
import { useRmTag } from '../../context/RmContext';
import { Block, LearnerInfo, Tenant } from '../../types';

interface CustomPageProps {
  blocks: (Block | null)[] | null;
  tenant?: Tenant | null;
  userInfo?: LearnerInfo;
  preventLoader?: boolean;
  blocksLoading?: boolean;
}

const CustomPage: React.FC<CustomPageProps> = ({
  blocks,
  preventLoader,
  tenant,
  userInfo,
  blocksLoading,
}) => {
  useRmTag(RM_TAGS.CustomPage);

  return (
    <CustomBlocks
      blocks={blocks}
      preventLoader={preventLoader}
      tenant={tenant}
      userInfo={userInfo}
      blocksLoading={blocksLoading}
    />
  );
};

export default CustomPage;
